module.exports = __webpack_public_path__ + "static/settings-horizontal-dark-a80ae6f302b9f723845c38e8cf66f971.svg";